import util from 'util'

export default (data) => (
  console.log(util.inspect(data, { depth: 7 }))
)
